/* eslint-disable import/prefer-default-export */
/**
 * VIEW에 제공할 패스워드 문자열.
 * 항상 웹 프로젝트의 CommonDefine.PASSWORD_FOR_VIEW와 동일하게 관리한다.
 * @type {String}
 */
export const PASSWORD_FOR_VIEW = '********';



// WEBPACK FOOTER //
// ./src/constants/common.js